import { Component } from '@angular/core';
import { TileComponent } from '@porscheinformatik/material-addons';

@Component({
  selector: 'app-tiles',
  imports: [TileComponent],
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss'],
})
export class TilesComponent {}
